import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

import { Card, CardHeader, CardBody, Col, Row } from 'reactstrap';
import CountUp from 'react-countup';
import GeneralStatisticChart from './GeneralStatisticChart';
import YearOverviewChart from './YearOverviewChart';
import SimpleBar from 'simplebar-react';
import { getFinances, getGeneralFinances, getTodayFinances } from '../../slices/thunks';
import Loader from './Loader';

const Widget = () => {
    const baseUrl = "https://autodijelovisefer.com/assets/";
    const dispatch = useDispatch();
    const store = createSelector(
        (state) => state.Finance,
        (state) => ({ 
            finances: state.finances,
            generalFinances: state.generalFinances,
            todayFinances: state.todayFinances
        }));

    const { finances, generalFinances, todayFinances } = useSelector(store);

    const [statistic, setStatistic] = useState([]);
    const [todayStatistic, setTodayStatistic] = useState([]);
    const [generalStatistic, setGeneralStatistic] = useState([]);
    
    useEffect(() => {
        dispatch(getGeneralFinances());
        dispatch(getFinances());
        dispatch(getTodayFinances());
        setStatistic(finances);
        setTodayStatistic(todayFinances);
        if (generalFinances && typeof generalFinances === 'object' && !Array.isArray(generalFinances)) {
            setGeneralStatistic([generalFinances.totalAvailable || 0, generalFinances.totalSold || 0, generalFinances.totalOnHold || 0]);
        }
    }, []);
    
    useEffect(() => {        
        setStatistic(finances);
        if (generalFinances && typeof generalFinances === 'object' && !Array.isArray(generalFinances)) {
            setGeneralStatistic([generalFinances.totalAvailable || 0, generalFinances.totalSold || 0, generalFinances.totalOnHold || 0]);
        }
    }, [finances, generalFinances]);
    return (
        <React.Fragment>
            <Row className="justify-content-center">
                <Col xxl={4}>
                    <Card>
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Lista dodanih dijelova</h4>                            
                        </div>
                        <CardBody>
                            <div className="table-responsive table-card">
                                <SimpleBar style={{ maxHeight: "408px" }}>
                                    <table className="table table-borderless align-middle">
                                        <tbody>
                                            {todayFinances.filter(item => item.activityType == 1).map((item, key) => (
                                                <tr key={key}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <img src={baseUrl +item.mainImage} alt="" className="avatar-sm" />
                                                            <div className="ms-3">
                                                                <h6 className="fs-15 mb-1">{item.publicIdentifier + " " + item.name}</h6>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-end">
                                                        <h6 className="fs-15 mb-1">{item.sellingPrice}KM</h6>
                                                    </td>
                                                </tr>))}
                                        </tbody>
                                    </table>
                                </SimpleBar>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xxl={4}>
                    <Card>
                        <div className="card-header align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Lista prodanih dijelova</h4>                            
                        </div>
                        <CardBody>
                            <div className="table-responsive table-card">
                                <SimpleBar style={{ maxHeight: "408px" }}>
                                    <table className="table table-borderless align-middle">
                                        <tbody>
                                            {todayFinances.filter(item => item.activityType == 3).map((item, key) => (
                                                <tr key={key}>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <img src={baseUrl +item.mainImage} alt="" className="avatar-sm" />
                                                            <div className="ms-3">
                                                                <h6 className="fs-15 mb-1">{item.publicIdentifier + " " + item.name}</h6>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-end">
                                                        <h6 className="fs-15 mb-1">{item.sellingPrice}KM</h6>
                                                    </td>
                                                </tr>))}
                                        </tbody>
                                    </table>
                                </SimpleBar>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row className="justify-content-center">
                <Col xl={3} md={4}>
                    <Card className="card-height-100">
                        <CardHeader className="align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Pregled skladišta</h4>
                        </CardHeader>{(!generalStatistic || !generalStatistic.length) ? ( <Loader /> ) : (<GeneralStatisticChart data={generalStatistic}/>)}
                        
                    </Card>
                </Col>
                <Col xl={3} md={4}>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-primary text-primary bg-opacity-25">
                                        <i className="bx bxs-store-alt"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Ukupno: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalFinances?.totalItems || 0}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-success text-success bg-opacity-25">
                                        <i className="bx bxs-check-circle"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Dostupno: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalFinances?.totalAvailableItems || 0}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-primary text-primary bg-opacity-25">
                                        <i className="bx bxs-badge-dollar"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Prodano: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalFinances?.totalSoldItems || 0}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-warning text-warning bg-opacity-25">
                                        <i className="bx bxs-time"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Na čekanju: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalFinances?.totalOnHoldItems || 0}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={6} md={4}>
                    <Card className="card-height-100">
                        <CardHeader className="align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Tekuća godina</h4>
                        </CardHeader>
                        {(!statistic || !statistic.length) ? ( <Loader /> ) : (<YearOverviewChart data={statistic}/>)}
                    </Card>                    
                </Col>
                
            </Row>
        </React.Fragment>
    );
};

export default Widget;


/*return (
        <React.Fragment>
            <Row>
                <Col xl={3} md={6}>
                    <Card className="card-height-100">
                        <CardHeader className="align-items-center d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">Opšti podaci o skladištu</h4>
                            <div className="flex-shrink-0">
                                <Dropdown className="card-header-dropdown" isOpen={isUserDropdown} toggle={toggleDropdown} direction="start">
                                    <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                                        <span className="text-muted fs-16">
                                            <i className="mdi mdi-dots-vertical align-middle"/>
                                        </span>
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-end" >
                                        <DropdownItem onClick={() => { onChangeChartPeriod("today"); }} className={selectedInterval === "today" ? "active" : ""}>Today</DropdownItem>
                                        <DropdownItem onClick={() => { onChangeChartPeriod("lastWeek"); }} className={selectedInterval === "lastWeek" ? "active" : ""}>Last Week</DropdownItem>
                                        <DropdownItem onClick={() => { onChangeChartPeriod("lastMonth"); }} className={selectedInterval === "lastMonth" ? "active" : ""}>Last Month</DropdownItem>
                                        <DropdownItem onClick={() => { onChangeChartPeriod("currentYear"); }} className={selectedInterval === "currentYear" ? "active" : ""}>Current Year</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </CardHeader>
                        <GeneralStatisticChart data={chartData}/>
                    </Card>
                </Col>
                <Col xl={3} md={6}>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-primary text-primary bg-opacity-25">
                                        <i className="bx bxs-store-alt"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Ukupno: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalStatistic.totalSoldItems}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-success text-success bg-opacity-25">
                                        <i className="bx bxs-check-circle"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Dostupno: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalStatistic.totalSoldItems}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-primary text-primary bg-opacity-25">
                                        <i className="bx bxs-badge-dollar"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Prodano: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalStatistic.totalSoldItems}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="card-height-25">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title rounded-2 fs-2 bg-warning text-warning bg-opacity-25">
                                        <i className="bx bxs-time"/>
                                    </span>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h3 className="fs-5 align-baseline">{"Na čekanju: "}
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={generalStatistic.totalOnHoldItems}
                                                separator={","}
                                                decimals={0}
                                                duration={4}
                                            />
                                        </span>
                                    </h3>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    ); */